import { UserDetails } from "src/tools/Auth/firebaseAuthRestAPI";

export class User extends UserDetails {
  destructObjectVariables(responseObj) {
    super.destructObjectVariables(responseObj);
    this.extraFields = responseObj.extraFields;
  }
}
